import { useRef } from "react";
import { stdObject } from "../../../data/types/stdObject";
import { emptys } from "../../../data/main";
import { monthsCodes } from "../../../screens/MainStructure/SearchBar/data/searchItemUtils";
import { useTranslation } from "react-i18next";

export default function OfferDay({
  index,
  innerIndex,
  day,
  updateOfferRowData,
}: stdObject) {
  const { t } = useTranslation();
  const dateRef = useRef<HTMLInputElement>(null);

  return (
    <div style={{ display: "flex", flexDirection: "row" }}>
      <div>
        <div
          onClick={() => {
            dateRef.current && dateRef.current.showPicker();
          }}
        >
          {innerIndex === 1 && " > "}
          {emptys.includes(day)
            ? t("p.new")
            : day
                .split("-")
                .map((v: string, idx: number) =>
                  idx ? Number(v) : t(monthsCodes[Number(v) - 1]),
                )
                .join(" ")}
        </div>
        <input
          ref={dateRef}
          type="date"
          onInput={(event) => {
            const target = event.target as HTMLInputElement;
            const mCode = emptys.includes(target.value)
              ? target.value
              : target.value
                  .split("-")
                  .map((o: string, idx: number) => (idx ? o : ""))
                  .join("-")
                  .slice(1);
            // console.log("mCode", mCode);
            updateOfferRowData("DAYS", mCode, [index, innerIndex]);
          }}
          style={{
            position: "absolute",
            width: 0,
            opacity: 0,
          }}
        />
      </div>
    </div>
  );
}
